query ListBimClassGeometryTypes (
    $id: ID!
) {
    geometryTypes(
        bimClassID: $id
    ) {
        id
        revisionID

        name(language: "en") {
            text
        }

        deprecated
    }
}
